class PlatformBehavior {
    ignoreLogBoxLogs() {
        //not yet available for web
    }
}

export default PlatformBehavior;